import classNames from "classnames";
import { useFormikContext } from "formik";
import { Switch, SwitchProps } from "./Switch";
import { ReactNode } from "react";

export const SwitchField = ({
  label,
  name,
  description,
  onChange,
  disabled = false,
  switchSide = "right",
  ...props
}: {
  label?: ReactNode;
  name: string;
  description?: string;
  onChange?: (value: boolean) => any;
  disabled?: boolean;
  switchSide?: "left" | "right";
} & SwitchProps) => {
  const { setFieldValue, getFieldMeta } = useFormikContext();

  const onCheckedChange = (value: boolean) => {
    setFieldValue(name, value);
    onChange?.(value);
  };
  if (!label) {
    return (
      <Switch
        disabled={disabled}
        checked={getFieldMeta<boolean>(name).value}
        name={name}
        onCheckedChange={onCheckedChange}
        {...props}
      />
    );
  }

  // An element, not an inline component: a component defined here would remount on every
  // render, and the remount makes Radix modals steal focus mid-Tab
  const switchElement = (
    <div className="t-shrink-0 t-flex t-justify-center t-items-center">
      <Switch
        id={name}
        disabled={disabled}
        checked={getFieldMeta<boolean>(name).value}
        name={name}
        onCheckedChange={onCheckedChange}
        {...props}
      />
    </div>
  );

  return (
    <div className="t-flex t-items-center t-justify-between t-gap-2">
      {switchSide === "left" && switchElement}
      {label && (
        <label htmlFor={name} className="t-cursor-pointer t-w-full t-flex">
          <span
            className={classNames("t-mr-2 t-inline-block t-text-body-sm", {
              "t-opacity-50 t-cursor-not-allowed": disabled === true,
            })}
          >
            {label}
          </span>
        </label>
      )}
      {switchSide === "right" && switchElement}
    </div>
  );
};
